'use client';

import type { ReactNode } from 'react';
import { SignalEditContentWrapper } from '../../HITL/wrappers/SignalEditContentWrapper';
import type { EditContentProps } from '../../tool-config-types';

export const renderSignalEditContent = (props: EditContentProps): ReactNode => (
  <SignalEditContentWrapper
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    onApprove={props.onApprove}
    onReject={props.onReject}
    toolName={props.toolName}
    extractedData={props.extractedData}
  />
);
